module.exports = __webpack_public_path__ + "static/contact@2x-4f267638757f6bf7d7995d45d0ee2c57.png";